// @flow

import { p2pLog } from '../logger'
import { getSwarmId, createStreamSwarmIdBuilder } from '../utils'
import { attachP2PDebug, detachP2PDebug } from '../debug'

let pluginsRegistered = false

export const destroyShakaP2PEngine = (engine: ?Object) => {
  if (!engine) {
    return
  }

  try {
    engine.destroy()
  } catch (err) {
    p2pLog('[P2P][Shaka] engine destroy failed:', err)
  }

  detachP2PDebug()
}

// eslint-disable-next-line complexity
export const createShakaP2PEngine = async ({
  shaka,
  player,
  srcUrl,
  p2pConfig,
}: {
  shaka: Object,
  player: Object,
  srcUrl: ?string,
  p2pConfig: ?Object,
}): Promise<Object> => {
  const [{ ShakaP2PEngine }, { computeStreamIdentityHash }] = await Promise.all([
    // eslint-disable-next-line import/no-unresolved -- exports-only package, resolved by webpack
    import('p2p-media-loader-shaka'),
    // eslint-disable-next-line import/no-unresolved -- exports-only package, resolved by webpack
    import('p2p-media-loader-core'),
  ])

  if (!pluginsRegistered) {
    ShakaP2PEngine.registerPlugins(shaka)
    pluginsRegistered = true
  }

  const swarmId = getSwarmId(srcUrl)
  const core = {
    ...p2pConfig,
    ...(swarmId && { swarmId }),
    streamSwarmIdBuilder: createStreamSwarmIdBuilder(computeStreamIdentityHash),
  }

  const engine = new ShakaP2PEngine({ core }, shaka)

  attachP2PDebug(engine, player)

  engine.bindShakaPlayer(player)

  p2pLog('[P2P][Shaka] engine bound, swarmId:', swarmId)

  return engine
}
